import { createEntityAdapter } from '@reduxjs/toolkit'

import { Runsheet } from '../models/runsheet/Runsheet'

export const runsheetsAdapter = createEntityAdapter({
  selectId: (runsheet: Runsheet) => runsheet.id,
})